import axios from "axios";

const instance = axios.create({
  baseURL: "https://us-central1-ontario-gsa.cloudfunctions.net/api", // THE API (cloud function) URL https://us-central1-ontario-gsa.cloudfunctions.net/api
  //'http://localhost:5001/ontario-gsa/us-central1/api' cd..
});

export default instance;
